<script src="entsorger-kunden-nr-verwalten-dialog.component.ts"></script
><h1 mat-dialog-title>Entsorger Kundennr.</h1>

<div mat-dialog-content>
    <kiene-entsorger-kunden-nr-verwalten (saved)="dialogRef.close($event)" [dialog]="true" [entsorger]="entsorger">
        <ng-container additional-actions>
            <button type="button" mat-button (click)="dialogRef.close()">Abbrechen</button>
        </ng-container>
    </kiene-entsorger-kunden-nr-verwalten>
</div>
